import { create } from "zustand";

// Global experience store. Scene reads via getState() inside useFrame to avoid
// re-rendering the R3F tree; HUD subscribes for reactive controls.
export const useStore = create((set) => ({
  // Perf-guard: auto-scaling LOD factor (1 = full quality, lower = fewer instances).
  qualityScale: 1,
  setQualityScale: (v) => set({ qualityScale: v }),

  // Temporal Bridge: 2001.0 -> 2026.0
  temporal: 2026.0,
  setTemporal: (v) => set({ temporal: v }),

  timelapse: false,
  toggleTimelapse: () => set((s) => ({ timelapse: !s.timelapse })),

  // Time of day 0..24
  timeOfDay: 13.5,
  setTimeOfDay: (v) => set({ timeOfDay: v }),

  // Weather: sunny | rain | snow | auto
  weather: "sunny",
  setWeather: (w) => set({ weather: w }),
  // Resolved weather when in auto mode
  autoWeather: "sunny",
  autoLocation: null,
  setAuto: (payload) => set(payload),

  // Navigation: orbit | walk | drive | bridge | hudson | helicopter | interior
  navMode: "orbit",
  // Reset manual zoom (fov) whenever the transit mode changes so zoom never leaks across modes.
  setNavMode: (m) => set({ navMode: m, fov: 50 }),
  interiorFloor: "f107",
  setInteriorFloor: (f) => set({ interiorFloor: f }),

  // Audio
  muted: true,
  toggleMuted: () => set((s) => ({ muted: !s.muted })),

  // Telemetry
  fps: 60,
  setFps: (v) => set({ fps: v }),

  // Focus a landmark (camera target request) -> {position:[], target:[]}
  focusRequest: null,
  requestFocus: (f) => set({ focusRequest: f }),
  clearFocus: () => set({ focusRequest: null }),

  // VR
  vrActive: false,
  setVrActive: (v) => set({ vrActive: v }),

  guestbookOpen: false,
  setGuestbookOpen: (v) => set({ guestbookOpen: v }),
  activeLandmark: "North Pool",
  setActiveLandmark: (l) => set({ activeLandmark: l }),

  // Walk-mode joystick input (mobile)
  walkMove: { f: 0, s: 0 },
  setWalkMove: (m) => set({ walkMove: m }),

  // Unified D-Pad input for all piloted modes {x:-1..1 (left/right), y:-1..1 (down/up)}
  dpad: { x: 0, y: 0 },
  setDpad: (d) => set({ dpad: d }),

  // Manual zoom (field of view) + camera reset
  fov: 50,
  setFov: (v) => set({ fov: v }),
  camResetNonce: 0,
  resetCamera: () => set((s) => ({ fov: 50, camResetNonce: s.camResetNonce + 1 })),
}));

// Effective weather (resolves 'auto').
export const getEffectiveWeather = (s) =>
  s.weather === "auto" ? s.autoWeather : s.weather;
